<h1 class="border-gray border-bottom text-center pb-4 mb-5">Website Menus</h1>

<div class="card border-0 bg-white shadow-sm mb-4">
    <div class="card-body p-xl-5">
        <div class="row">
            <div class="col-lg-2">
                <h3>Menu groups</h3>
                <ng-container *ngIf="menuGroup">
                    <button
                        class="btn btn-block mb-2"
                        (click)="setMenuGroup(mgIdx)"
                        [ngClass]="mg.id === menuGroup.id ? 'btn-primary' : 'btn-white'"
                        *ngFor="let mg of menuGroups; let mgIdx = index">
                        {{mg.name}}
                    </button>
                </ng-container>
            </div>

            <div class="col-lg-5">
                <h3>Menu group items</h3>
                <div class="dd">
                    <button class="btn btn-primary" (click)="createMenu(undefined, 0, 1)">Add menu item</button>
                    <ol class="dd-list mt-2"
                        dragula="priCategory"
                        [(dragulaModel)]="menus"
                        (dragulaModelChange)="drop($event)">
                        <li *ngFor="let menu of menus"
                            class="dd-item"
                            [ngClass]="{'dd-collapsed' : !menu.open}">
                            <div class="dd-handle">
									<span class="label label-info" >
										<i class="fa fa-bars"></i>
									</span>

                                <span class="float-right">
										<a (click)="setsubMenu(menu)" style="margin-left: 10px">
											<i class="fa fa-chevron-right"></i>
										</a>
									</span>
                                <span class="float-right">
										<a (click)="deleteConfirm(menu)" style="margin-left: 10px">
                                            <img src="assets/images/icon-trash.svg" class="menus-trash">
										</a>
									</span>
                                <span class="float-right">
										<a class="ms-2" (click)="createMenu(menu, 0, 0)">
                                            <img src="assets/images/icon-edit.svg" class="menus-edit">
										</a>
									</span>

                                <!--									<span class="float-right"> {{menu.secondaryMenus.length}} sub menus </span>-->
                                {{menu.name}}
                            </div>
                        </li>

                    </ol>
                </div>

            </div>
            <div class="col-lg-5">

                <div class="dd">
                    <button
                        *ngIf="subMenu"
                        class="btn btn-primary"
                        (click)="createMenu(undefined, primaryMenu.id, primaryMenu.level + 1)">
                        Add category
                    </button>
                    <ol class="dd-list"
                        dragula="subCats"
                        [(dragulaModel)]="subMenu"
                        (dragulaModelChange)="dropSub($event)">
                        <li *ngFor="let menu of subMenu"
                            class="dd-item"
                            [ngClass]="{'dd-collapsed' : !menu.open}">

                            <div class="dd-handle">
									<span class="float-right">
										<a (click)="deleteConfirm(menu)">
											<i class="fa fa-trash"></i>
										</a>
									</span>
                                <span class="float-right">
										<a class="me-2" (click)="createMenu(menu, 0, 0)">
											<i class="fa fa-edit"></i>

										</a>
									</span>
                                <span class="label label-info" >
									<i class="fa fa-bars"></i>
								</span>

                                {{menu.name}}
                            </div>
                        </li>

                    </ol>
                </div>



            </div>
        </div>
    </div>
</div>

<app-edit-menu *ngIf="showCreateModal" [currentMenu]="currentMenu" [menuGroup]="menuGroup" [parentId]="parentId" [level]="level" (modalAction)="createModalAction($event)"></app-edit-menu>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>

